module.exports = {"540402001":"白玛岗街道","540402002":"觉木街道","540402100":"林芝镇","540402101":"百巴镇","540402102":"八一镇","540402103":"鲁朗镇","540402200":"更章门巴民族乡","540402202":"布久乡","540402203":"米瑞乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540402.json
// module id = 2852
// module chunks = 0